module.exports = __webpack_public_path__ + "img/3.5909d189.jpg";